import React from 'react'
import { View } from 'react-native'
import { ContentLoader, Rect } from '@src/components/ContentLoader'
import { StyleService, useStyleSheet } from '@src/style/service'

interface LoadingCardProps {
  showButton?: boolean
}

export const LoadingCard = ({ showButton }: LoadingCardProps) => {
  const styles = useStyleSheet(themedStyles)

  const height = showButton ? 189 : 100

  return (
    <View style={[styles.card, { height }]}>
      <View style={styles.container}>
        <ContentLoader variant="card" style={styles.loader}>
          <Rect x="0" y="0" width="64" height="68" rx="12" ry="12" />
          <Rect x="80" y="0" width="50%" height="17" rx="4" ry="4" />
          <Rect x="80" y="24" width="75%" height="13" rx="4" ry="4" />
          <Rect x="80" y="42" width="65%" height="13" rx="4" ry="4" />
          {showButton && (
            <>
              <Rect x="0" y="84" width="100%" height="1" />
              <Rect x="0" y="101" width="100%" height="56" rx="28" ry="28" />
            </>
          )}
        </ContentLoader>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  card: {
    gap: 16,
    borderRadius: 16,
    padding: 16,
    backgroundColor: 'theme.surface.base3',
  },
  container: {
    flex: 1,
  },
  loader: {
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
})
